import { Controller } from "stimulus";
import {loadDataVehicles, loadRegionData, loadRibbonColours} from "../utils/controller-helper";
const jsonUrl = "/content/json/";

export default class extends Controller {
    async initialize() {
        import(/* webpackChunkName: "vehicles-filters" */ '../components/VehiclesFilters').then(async module => {
            // console.log(this.element, module);
            try {
                const vehicleResponse = await loadDataVehicles();
                const modelResponse = await this.loadDataModels();
                const regionResponse = await loadRegionData()
                const ribbonData = await loadRibbonColours()

                module.default(this.element, {
                    vehicles: vehicleResponse,
                    models: modelResponse,
                    regions: regionResponse,
                    ribbonData: ribbonData
                });
            } catch (error) {
                console.error('Error loading data:', error);
            }
        })
    }

    async loadDataModels() {
        try {
            const response = await fetch(jsonUrl + "models.json");
            return await response.json();
        } catch (error) {
            console.error('Error fetching JSON:', error);
        }

    }

}